import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'

function useHistoryWithReturnUrl() {
    const location = useLocation()
    const history = useHistory()

    const replace = useCallback(
        (path: string, state?: any) => {
            const { returnUrl } = queryString.parse(location.search)
            if (returnUrl && typeof returnUrl === 'string')
                history.push(returnUrl)
            else history.replace(path, state)
        },
        [history, location.search],
    )

    const push = useCallback(
        (path: string, state?: any) => {
            const { returnUrl } = queryString.parse(location.search)
            if (returnUrl && typeof returnUrl === 'string')
                history.push(returnUrl)
            else history.push(path, state)
        },
        [history, location.search],
    )

    const goBack = useCallback(() => {
        const { returnUrl } = queryString.parse(location.search)
        if (returnUrl && typeof returnUrl === 'string')
            history.replace(returnUrl)
        else history.goBack()
    }, [history, location.search])

    return {
        native: history,
        replace,
        push,
        goBack,
    }
}

export default useHistoryWithReturnUrl
